const withPoint = point => prevPoints => [...prevPoints, point];

export default withPoint;
